import React, { useState, useContext } from "react";

import { LanguageContext } from "../context/LanguageContext"

function DemoRq() {

    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

    return (
        <>

        <div className="box12">

            <h2 >{t('demoT1')}</h2>
            <img class= "image" src= "https://storage.googleapis.com/tt202501/images/Techtalamo_service1.png" ></img>

                <p className="text2" >
                {t('demoT2')} 
                </p>         
                 <a href="https://docs.google.com/forms/d/e/1FAIpQLSd20rcu8gJTXN0faf7IfEYCV-5oqPFMzvD_RHayk19lCUdNig/viewform?usp=sharing" target="_blank" className="bigmail"> <button className="button5">    <h1 >{t('demoT3')}</h1> </button></a>
                <br/>
                
                <br/>
                <p>
                {t('demoT4')} 
                <a href="mailto:info@techtalamo.com"  > info@techtalamo.com</a>
                </p>

        </div>

        </>
        )
        }
        export default DemoRq



